LOGIN_ENDPOINT = '/workflow/api/v1/rpc/login/'

module.exports = ($q, settings, $state, $stateParams, $location, $http) ->
  @redirectToLogin = (badPermission) ->
    if $location.url().indexOf('login/') > -1
      $state.go('not-logged-in', {previous_url: $stateParams.previous_url})
    else
      $state.go('not-logged-in', {previous_url: $location.url(), bad_permission: badPermission})

  @makeLoginRequest = (username, password, csrf, success, error) ->
    $http({
      method: 'POST'
      url: LOGIN_ENDPOINT
      data: $.param({username: username, password: password, csrfmiddlewaretoken: csrf})
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
    .success(success)
    .error(error)

  return # stops coffee compiler doing the wrong thing
